import { useCallback, useContext, useEffect, useMemo, useState } from 'react';

import classnames from 'classnames';

import { MainContext } from '@ezbobdev/ui-framework';

export const useBody = (props) => {
  const { actions, view } = useContext(MainContext);
  const [screensContent, setScreensContent] = useState([]);
  const modalName = actions.view.getView('modal.modalName');
  const { className } = props;
  const { alerts } = view;

  const addScreenContent = useCallback(
    (content, id) => {
      if (id) {
        const state = [...screensContent];
        state[id].content = content;
        setScreensContent((prevState) => [...state]);
        return screensContent.length;
      }

      setScreensContent([...screensContent, { content, screePageYOffset: window.pageYOffset }]);
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
      return id;
    },
    [screensContent],
  );

  const removeScreenContent = useCallback(() => {
    actions.view.clearAlerts();
    if (screensContent.length) {
      const lastScreen = screensContent.pop();
      const lastScreePageYOffset = lastScreen.screePageYOffset;
      setScreensContent((prevState) => [...screensContent]);
      window.scroll({ top: lastScreePageYOffset, left: 0, behavior: 'smooth' });
    }
  }, [screensContent]);

  const getModalNameClass = useCallback(() => {
    return modalName ? `modal_${modalName}` : undefined;
  }, [modalName]);

  const wrapperClasses = useMemo(
    () => classnames(`Body`, getModalNameClass(), className),
    [getModalNameClass, className],
  );

  useEffect(() => {
    actions.view.scrollToWidget('Alerts');
    actions.view.scrollToWidget('MaterialAlerts');
  }, [alerts]);

  useEffect(() => {
    actions.view.addScreenContent = addScreenContent;
    actions.view.removeScreenContent = removeScreenContent;
  }, [removeScreenContent]);

  return { alerts, screensContent, wrapperClasses };
};
